jQuery(document).ready(function ($) {
    // Add custom class to Yoast FAQ block
    $('.wp-block-yoast-faq-block').addClass('fcp-faq');

    // Toggle class for FAQ question click
    $('.wp-block-yoast-faq-block .schema-faq-question').click(function () {
        $(this).parent().toggleClass('fcp-opened');
    });

    // Initialize GSAP animations with ScrollTrigger
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);

        gsap.from('.scroll-animate', {
            opacity: 0,
            y: 50,
            duration: 1,
            ease: 'power2.out',
            scrollTrigger: {
                trigger: '.scroll-animate',
                start: 'top 90%',
                end: 'bottom 10%',
                toggleActions: 'play none none none',
            },
        });
    } else {
        console.error('GSAP or ScrollTrigger is not loaded.');
    }
});
